export type UserRole =
  | 'admin'
  | 'cxo'
  | 'supervisor'
  | 'finance'
  | 'account_manager'
  | 'customer_support'
  | 'fpo'
  | 'vlcc'
  | 'retailer'
export type UserStatus = 'active' | 'inactive' | 'pending_kyc' | 'kyc_rejected'

// Roles creatable via the internal admin panel (POST /users/register). fpo/vlcc/retailer
// are external roles onboarded through the KYC flow instead.
export const INTERNAL_ROLES: UserRole[] = [
  'admin',
  'cxo',
  'supervisor',
  'finance',
  'account_manager',
  'customer_support',
]

export interface User {
  id: string
  keycloakId: string
  name: string
  role: UserRole
  phone: string
  email?: string
  status: UserStatus
  createdAt: string
  updatedAt: string
}
